import { ComponentChildren, JSX } from 'preact';
import { forwardRef } from 'preact/compat';
import { CommonStackProps } from './Stack.interface';
import { Container } from './Stack.styles';

interface StackProps extends CommonStackProps {
  component?: keyof JSX.IntrinsicElements;
  children?: ComponentChildren;
  className?: string;
  onClick?: () => void;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Stack = forwardRef<any, StackProps>((props, ref) => {
  const { component = 'div', children, onClick, ...rest } = props;
  return (
    <Container ref={ref} as={component} onClick={onClick} {...rest}>
      {children}
    </Container>
  );
});

Stack.displayName = 'Stack';

export { Stack, StackProps };
